import React from 'react';
import { Route } from 'react-router-dom';
import { View } from '../../../../components';
import { applet, view, shortView } from './core';

const ParticipateView = React.lazy(() => import('./ParticipateView'));

// Aceita os dois paths:
//   - `/p/participe/:organization` — URL canônica (compartilhada por outras
//     telas que linkam usando applet=`/p/participe`).
//   - `/:organization` — URL curta, válida apenas quando o bundle `publico`
//     é servido via subdomínio `participe.suaformatura.com` (nginx
//     diferencia por Host; ver `coruja/infra/nginx/coruja.conf`).
export default (
  <Route exact key={view} path={[view, shortView]}>
    <View view={view} applet={applet} component={ParticipateView} />
  </Route>
);
